import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { PartnerDto } from "services/partners/restModels";
import { formatPhoneNumber } from "shared/lib/phoneNumber";
import { ActionMenu } from "shared/ui/ActionMenu";
import { DataTable, DataTableColumn } from "shared/ui/DataTable";
import { IconButton } from "shared/ui/IconButton";
import { MoreIcon } from "shared/ui/icons";

import { formatPercent } from "../percent";

interface PartnersTableProps {
    items: PartnerDto[];
    onEdit: (partner: PartnerDto) => void;
    onChangeAccount: (partner: PartnerDto) => void;
    onDelete: (partner: PartnerDto) => void;
}

export const PartnersTable = ({ items, onEdit, onChangeAccount, onDelete }: PartnersTableProps) => {
    const history = useHistory();
    const [menu, setMenu] = useState<{ partner: PartnerDto; anchorEl: HTMLElement } | null>(null);

    const columns: DataTableColumn<PartnerDto>[] = [
        {
            key: "name",
            title: "Название",
            role: "primary",
            width: 280,
            render: (partner) => partner.name,
        },
        {
            key: "phone",
            title: "Аккаунт",
            role: "secondary",
            grow: true,
            render: (partner) => (partner.phoneNumber ? formatPhoneNumber(partner.phoneNumber) : "—"),
        },
        {
            key: "percent",
            title: "Вознаграждение",
            role: "secondary",
            width: 130,
            render: (partner) => formatPercent(partner.commissionPercent),
        },
        {
            key: "branches",
            title: "Заведений",
            role: "secondary",
            width: 100,
            render: (partner) => partner.branchesCount,
        },
        {
            key: "actions",
            role: "action",
            width: 56,
            render: (partner) => (
                <IconButton
                    label="Действия"
                    onClick={(event) => setMenu({ partner, anchorEl: event.currentTarget })}
                >
                    <MoreIcon />
                </IconButton>
            ),
        },
    ];

    const runAndClose = (action: (partner: PartnerDto) => void) => () => {
        if (menu) action(menu.partner);
        setMenu(null);
    };

    return (
        <>
            <DataTable
                columns={columns}
                rows={items}
                rowKey={(partner) => partner.id}
                onRowClick={(partner) => history.push(`/partners/general/${partner.id}`)}
            />

            <ActionMenu
                open={menu !== null}
                onClose={() => setMenu(null)}
                anchorEl={menu?.anchorEl ?? null}
                title={menu?.partner.name}
                items={[
                    { key: "edit", label: "Изменить", onClick: runAndClose(onEdit) },
                    { key: "account", label: "Сменить аккаунт", onClick: runAndClose(onChangeAccount) },
                    {
                        key: "delete",
                        label: "Удалить",
                        tone: "danger",
                        separated: true,
                        onClick: runAndClose(onDelete),
                    },
                ]}
            />
        </>
    );
};
